// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';
import {Customer} from '../customer';

export const MergeCustomerItem = Customer.extend({
    isPrimaryCustomer: t.Boolean
}, 'MergeCustomerItem');

const MergeCustomerList = t.list(MergeCustomerItem, 'MergeCustomerList');

export const MergeCustomer = t.struct({
    comments: t.maybe(t.String),
    list: MergeCustomerList
}, {
    defaultProps: {
        comments: '',
        list: []
    },
    name: 'MergeCustomer',
    strict: true
});

MergeCustomer.prototype.isPrimaryCustomerSelected = function () {
    return this.list.some((item) => item.isPrimaryCustomer) && this.list.length > 1;
};
